import apiClient from './apiClient';

const API_URL = '/tramites/generico';

// Listar / filtrar trámites genéricos
export const getTramitesGenerico = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite genérico
export const getTramiteGenericoById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite genérico
export const crearTramiteGenerico = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite genérico:', error.response?.data || error.message);
        throw error;
    }
};

// Editar datos del trámite (no el cliente)
export const actualizarTramiteGenerico = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable con firma)
export const actualizarComentariosGenerico = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

const genericoService = {
    getTramitesGenerico,
    getTramiteGenericoById,
    crearTramiteGenerico,
    actualizarTramiteGenerico,
    actualizarComentariosGenerico,
};

export default genericoService;
